import { ImgHTMLAttributes, useContext } from 'react';
import { ProductScreenContext } from '../../contexts/product-screen-context';
import { StyledHeaderImage } from './styled';

interface HeaderImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  position: 'left' | 'center' | 'right';
}

export function HeaderImage({
  position,
  ...props
}: HeaderImageProps): JSX.Element {
  const context = useContext(ProductScreenContext);
  return (
    <StyledHeaderImage position={position}>
      <img
        src={context?.productScreen.screen.image}
        {...props}
        alt={props.alt}
      />
    </StyledHeaderImage>
  );
}
